export type PerfMeta = Record<string, unknown>;

export function isPerfDebugEnabled(): boolean {
  // Never spam production consoles
  if (process.env.NODE_ENV === "production") return false;
  try {
    if (typeof window === "undefined") return false;
    const qs = new URLSearchParams(window.location.search);
    if (qs.get("perf") === "1" || qs.get("perf") === "true") return true;
    return localStorage.getItem("perf") === "1";
  } catch {
    return false;
  }
}

export function perfNow(): number {
  try {
    // eslint-disable-next-line no-restricted-globals
    return typeof performance !== "undefined" && typeof performance.now === "function"
      ? performance.now()
      : Date.now();
  } catch {
    return Date.now();
  }
}

export function bytesToHuman(bytes: number | null | undefined): string {
  const b = typeof bytes === "number" && Number.isFinite(bytes) ? bytes : 0;
  if (b < 1024) return `${b} B`;
  const kb = b / 1024;
  if (kb < 1024) return `${kb.toFixed(1)} KB`;
  const mb = kb / 1024;
  if (mb < 1024) return `${mb.toFixed(2)} MB`;
  const gb = mb / 1024;
  return `${gb.toFixed(2)} GB`;
}

export function perfLog(label: string, meta?: PerfMeta) {
  if (!isPerfDebugEnabled()) return;
  // Keep logs grep-friendly and structured
  // eslint-disable-next-line no-console
  console.log(`[perf] ${label}`, meta ?? {});
}

export function perfGroup(label: string, meta?: PerfMeta) {
  if (!isPerfDebugEnabled()) return;
  // eslint-disable-next-line no-console
  console.groupCollapsed(`[perf] ${label}`);
  if (meta) {
    // eslint-disable-next-line no-console
    console.log(meta);
  }
}

export function perfGroupEnd() {
  if (!isPerfDebugEnabled()) return;
  // eslint-disable-next-line no-console
  console.groupEnd();
}


